export default {"src":"/_next/static/media/SportsInjuriesjhk.b368dee2.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};